import React from "react";
import {CardItens} from "./styleComponentes";


export const CardFeatures = ({icon, texto, left}) => {
    return(
        <CardItens left={left}>
            <div>{icon}</div>
            <p>
                {texto}
            </p>
        </CardItens>
    )
};